import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import classNames from 'classnames/bind';
import get from 'lodash/get';
import lowerCase from 'lodash/lowerCase';
import upperCase from 'lodash/upperCase';
import Button from 'yoda-core-components/lib/components/Button';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import ExternalLink from 'yoda-core-components/lib/assets/svg/ExternalLink.svg';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import ThrottleFeatureRender from '../ThrottleFeatureRender/ThrottleFeatureRender';
import ApplySyfLink from '../ApplySyfLink/ApplySyfLink';
import plccHelper from '../../helpers/Utils/plccHelper';
import * as styles from './PLCCBanner.css';
import {
    DP_HAS_JCP_CARD,
    PLCC_BANNER_CARDS_JCP_CARD,
    PLCC_BANNER_CARDS_PLATINUM_TIER,
} from '../../common/Constants';

const cx = classNames.bind(styles);

class PLCCBanner extends Component {
    static propTypes = {
        preferences: PropTypes.objectOf.isRequired,
        enableRewardsRelaunch: PropTypes.bool,
        messagesTexts: PropTypes.objectOf.isRequired,
        plccBannerDetails: PropTypes.objectOf(PropTypes.any).isRequired,
        actions: PropTypes.objectOf(PropTypes.func).isRequired,
        isCAMNavBanner: PropTypes.bool,
        isSliderBanner: PropTypes.bool,
        signInSliderActions: PropTypes.objectOf(PropTypes.func),
        analyticsAction: PropTypes.objectOf(PropTypes.func),
        enablePlccBanner: PropTypes.bool,
        userState: PropTypes.string,
    };

    static defaultProps = {
        isSliderBanner: false,
        isCAMNavBanner: false,
        plccBannerDetails: {},
        signInSliderActions: {},
        analyticsAction: {},
        enablePlccBanner: false,
        userState: '',
        enableRewardsRelaunch: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            hasJCPCard: TokenProvider.get(DP_HAS_JCP_CARD) || 'false',
        };
    }

    componentDidMount() {
        const { hasJCPCard } = this.state;
        const {
            userState,
            enablePlccBanner,
            actions,
            analyticsAction,
            isCAMNavBanner,
            preferences,
        } = this.props;
        if (enablePlccBanner && (userState === '1' || userState === '2') && hasJCPCard === 'true') {
            actions.getRequestPLCCBanner();
        }
        const creditCardLink = isCAMNavBanner
            ? get(preferences, 'plccBanner.creditCardLinkMobile')
            : get(preferences, 'plccBanner.creditCardLink');
        plccHelper(analyticsAction.plccApplyAnalytics, {
            plccBanner: 'static_accountsignin',
            href: creditCardLink,
        });
    }

    getLeftPositionOfProgressBar = () => {
        const { plccBannerDetails: bannerDetails } = this.props;
        const earnedPoints = get(bannerDetails, 'response.yearToDtSpendInt');
        const thresholdPoints = get(bannerDetails, 'response.reachToNextTierThreshold');
        let width = 100;
        let maxWidth = 'none';
        if (earnedPoints < thresholdPoints) {
            width = (earnedPoints / thresholdPoints) * 100;
            maxWidth = '80%';
        }
        return {
            width: `${width}%`,
            maxWidth,
        };
    };

    addToWallet = () => {
        const { signInSliderActions, preferences } = this.props;
        signInSliderActions.initiateSignInSliderClose();
        window.location.assign(`${get(preferences, 'navigateToPaymentMethods.desktop')}?type=add`);
    };

    bannerNextTier = (currentTierCard) => {
        if (lowerCase(currentTierCard) === 'red') {
            return 'gold';
        }
        if (lowerCase(currentTierCard) === 'gold') {
            return 'platinum';
        }
        return lowerCase(currentTierCard);
    };

    linkToCard = (url) => {
        window.open(url, '_blank');
    };

    render() {
        const {
            preferences,
            messagesTexts,
            isSliderBanner,
            plccBannerDetails: bannerDetails,
            userState,
            isCAMNavBanner,
            enableRewardsRelaunch,
        } = this.props;
        const { hasJCPCard } = this.state;
        const isHotOrWarmState = userState === '1' || userState === '2';
        const bannerType = isSliderBanner ? 'sliderBanner' : 'pageBanner';
        const cardType = upperCase(get(bannerDetails, 'response.cardType', ''));
        const bannerTierType = lowerCase(get(bannerDetails, 'response.tierCode', ''));
        const bannerDefaultImage = get(
            preferences,
            'plccBanner.hotStateStackedImage',
            '/static-account/assets/images/plccblackdualcard.png'
        );
        const bannerDefaultTitle = enableRewardsRelaunch
            ? get(preferences, 'plccBanner.newTitle', '')
            : get(preferences, 'plccBanner.title', '');
        const bannerDefaultSubTitle = get(preferences, 'plccBanner.subTitle', []);
        const bannerNextTierType = this.bannerNextTier(bannerTierType);
        const bannerCardMemberLink = get(preferences, 'plccBanner.cardMemberLink', '');
        const viewDetails = get(preferences, 'plccBanner.viewDetails', '');
        const isProgressBarRequired =
            cardType === 'JCP' && bannerTierType !== 'platinum' && bannerTierType !== '';
        const leftPosition = isProgressBarRequired ? this.getLeftPositionOfProgressBar() : {};
        const spentAmount = get(bannerDetails, 'response.yearToDtSpendInt');
        const thresholdAmount = get(bannerDetails, 'response.reachToNextTierThreshold');
        const tierTypeSubTitle = get(
            preferences,
            `plccBanner.${cardType}.${bannerTierType}.subTitle`,
            []
        );
        const spendMoreText =
            get(bannerDetails, 'response.spendToNextTierInt') !== undefined
                ? `$${get(bannerDetails, 'response.spendToNextTierInt')}`
                : '';
        const goldNextTierImage =
            cardType === 'JCP' && bannerTierType === 'gold' ? 'nextImage' : 'image';
        const showViewBalanceAndPayLink =
            !isHotOrWarmState || (isHotOrWarmState && hasJCPCard !== 'false');
        const isPlatinumPlccCard = cardType === 'JCP' && bannerTierType === 'platinum';
        const isThresholdExceeded =
            spentAmount > thresholdAmount ||
            get(bannerDetails, 'response.spendToNextTierInt') === 0;
        const thresholdExceededSubTitle = get(
            preferences,
            `plccBanner.${cardType}.${bannerTierType}.thresholdExceededSubTitle`,
            []
        );
        const creditCardLink = isCAMNavBanner
            ? get(preferences, 'plccBanner.creditCardLinkMobile')
            : get(preferences, 'plccBanner.creditCardLink');
        return (
            <div
                className={`${cx('plccBannerWrapper', bannerType)} ${dt([
                    'px-6',
                    'py-6',
                    'bg-white',
                ])}`}
                data-qm-block="true"
            >
                <div
                    className={`${cx('plccBanner')} ${dt(['text-black', 'text-center'])}`}
                    data-automation-id="jcp_credit_card_container"
                >
                    <div
                        className={`${cx(isSliderBanner ? '' : 'sm12 md12 lg3 xl3', 'plccIcon', {
                            plccIconSlide: isSliderBanner,
                        })} ${dt([
                            isSliderBanner && 'relative',
                            isSliderBanner && 'top-[5px]',
                            isSliderBanner && 'mb-2.5',
                        ])}`}
                    >
                        {isSliderBanner ? (
                            <>
                                {(cardType !== PLCC_BANNER_CARDS_JCP_CARD ||
                                    (cardType === PLCC_BANNER_CARDS_JCP_CARD &&
                                        (bannerTierType === PLCC_BANNER_CARDS_PLATINUM_TIER ||
                                            bannerTierType === ''))) && (
                                    <img
                                        className={dt([
                                            'relative',
                                            'sm:max-w-[78px]',
                                            'my-0',
                                            'mx-auto',
                                        ])}
                                        src={get(
                                            preferences,
                                            `plccBanner.${cardType}.${bannerTierType}.image`,
                                            bannerDefaultImage
                                        )}
                                        alt="Plcc banner"
                                    />
                                )}
                            </>
                        ) : (
                            <div>
                                <svg width="51px" height="31px" viewBox="0 0 24 15">
                                    <defs>
                                        <linearGradient
                                            id="jcpCardRed"
                                            x1="4.258%"
                                            x2="41.417%"
                                            y1="33.41%"
                                            y2="66.808%"
                                        >
                                            <stop offset="0%" stopColor="#D21D35" />
                                            <stop offset="100%" stopColor="#B11529" />
                                        </linearGradient>
                                    </defs>
                                    <path
                                        fill="url(#jcpCardRed)"
                                        d="M0 2.009C0 .899.897 0 2.005 0H22c1.108 0 2.005.896 2.005 2.009v10.652c0 1.11-.897 2.009-2.005 2.009H2.005A2.005 2.005 0 0 1 0 12.661V2.009z"
                                    />
                                    <path
                                        fill="#FFF"
                                        d="M3.93 7.294c0 .289-.042.513-.126.673-.156.292-.453.437-.89.437-.251 0-.467-.07-.645-.208C2.089 8.057 2 7.81 2 7.455V7.21h.429v.245c0 .186.04.326.122.42.082.094.21.14.382.14.243 0 .402-.084.476-.253.046-.104.07-.3.07-.589V4.894h.45v2.4zm2.87-2.15c.235.227.365.487.391.777h-.444a.943.943 0 0 0-.302-.524c-.15-.129-.361-.193-.633-.193-.332 0-.6.118-.803.355-.204.236-.306.6-.306 1.088 0 .4.092.725.276.974.184.25.459.374.824.374.336 0 .592-.131.767-.394a1.51 1.51 0 0 0 .209-.544h.444c-.04.36-.17.661-.394.905-.267.293-.628.44-1.081.44-.391 0-.72-.12-.985-.36-.35-.319-.525-.81-.525-1.474 0-.505.131-.918.394-1.24.284-.352.676-.527 1.175-.527.426 0 .757.114.992.342zm.787-.25H9.1c.3 0 .54.086.724.257.183.172.275.413.275.723 0 .267-.082.5-.245.697-.164.198-.415.297-.754.297H8.043v1.446h-.456v-3.42zm1.778.47a.979.979 0 0 0-.415-.072h-.907v1.185h.907c.204 0 .37-.044.498-.133.128-.088.191-.244.191-.468 0-.25-.091-.422-.274-.512zm2.546.525c.164.083.288.19.374.323.082.125.137.272.165.44.024.114.036.298.036.549h-1.798c.007.253.066.456.176.609.11.152.28.229.511.229a.655.655 0 0 0 .516-.217.733.733 0 0 0 .155-.29h.406a.877.877 0 0 1-.107.306c-.06.112-.127.204-.202.275a.956.956 0 0 1-.465.252c-.1.025-.212.037-.337.037-.306 0-.565-.113-.777-.339-.212-.225-.318-.542-.318-.948 0-.4.107-.726.32-.975a1.05 1.05 0 0 1 .839-.375c.174 0 .343.041.506.124zm.152.98a1.099 1.099 0 0 0-.117-.436c-.113-.202-.302-.303-.566-.303-.19 0-.348.07-.477.209a.794.794 0 0 0-.204.53h1.364zm.695-1.048h.392v.353c.116-.145.239-.25.369-.314a.97.97 0 0 1 .433-.095c.348 0 .583.123.705.37.068.135.101.328.101.58v1.599h-.419V6.742a.863.863 0 0 0-.066-.367c-.074-.156-.207-.233-.4-.233a.8.8 0 0 0-.24.03.62.62 0 0 0-.298.205.62.62 0 0 0-.134.255c-.02.088-.03.213-.03.376v1.306h-.413V5.82zm2.375 0h.392v.353c.116-.145.239-.25.369-.314a.97.97 0 0 1 .433-.095c.348 0 .583.123.705.37.068.135.101.328.101.58v1.599h-.42V6.742a.863.863 0 0 0-.066-.367c-.073-.156-.206-.233-.398-.233a.8.8 0 0 0-.24.03.62.62 0 0 0-.299.205.62.62 0 0 0-.134.255c-.02.088-.03.213-.03.376v1.306h-.413V5.82zm3.903.068c.164.083.288.19.374.323.082.125.137.272.165.44.024.114.036.298.036.549h-1.798c.007.253.066.456.176.609.11.152.28.229.511.229a.655.655 0 0 0 .516-.217.733.733 0 0 0 .155-.29h.406a.877.877 0 0 1-.107.306c-.06.112-.128.204-.202.275a.956.956 0 0 1-.466.252c-.099.025-.211.037-.336.037-.306 0-.565-.113-.777-.339-.212-.225-.318-.542-.318-.948 0-.4.106-.726.32-.975a1.05 1.05 0 0 1 .839-.375c.174 0 .343.041.506.124zm.151.98a1.099 1.099 0 0 0-.116-.436c-.113-.202-.302-.303-.566-.303-.19 0-.349.07-.477.209a.794.794 0 0 0-.204.53h1.363zm2.229-1.048h.456c-.058.16-.187.524-.388 1.094-.15.428-.274.777-.375 1.047-.239.636-.407 1.024-.504 1.164-.098.14-.266.21-.504.21a.974.974 0 0 1-.134-.008 1.044 1.044 0 0 1-.116-.025V8.92c.072.02.124.033.156.037.032.005.06.007.084.007.077 0 .133-.012.169-.038a.352.352 0 0 0 .09-.094 11.946 11.946 0 0 0 .186-.447l-.907-2.565h.467l.658 2.03.662-2.03z"
                                    />
                                </svg>
                                <svg width="51px" height="31px" viewBox="0 0 24 15">
                                    <defs>
                                        <linearGradient
                                            id="jcpCardGold"
                                            x1="4%"
                                            x2="41%"
                                            y1="33%"
                                            y2="66%"
                                        >
                                            <stop offset="0%" stopColor="#E6A617" />
                                            <stop offset="100%" stopColor="#AE7D10" />
                                        </linearGradient>
                                    </defs>
                                    <path
                                        fill="url(#jcpCardGold)"
                                        d="M0 2.009C0 .899.897 0 2.005 0H22c1.108 0 2.005.896 2.005 2.009v10.652c0 1.11-.897 2.009-2.005 2.009H2.005A2.005 2.005 0 0 1 0 12.661V2.009z"
                                    />
                                    <path
                                        fill="#FFF"
                                        d="M3.93 7.294c0 .289-.042.513-.126.673-.156.292-.453.437-.89.437-.251 0-.467-.07-.645-.208C2.089 8.057 2 7.81 2 7.455V7.21h.429v.245c0 .186.04.326.122.42.082.094.21.14.382.14.243 0 .402-.084.476-.253.046-.104.07-.3.07-.589V4.894h.45v2.4zm2.87-2.15c.235.227.365.487.391.777h-.444a.943.943 0 0 0-.302-.524c-.15-.129-.361-.193-.633-.193-.332 0-.6.118-.803.355-.204.236-.306.6-.306 1.088 0 .4.092.725.276.974.184.25.459.374.824.374.336 0 .592-.131.767-.394a1.51 1.51 0 0 0 .209-.544h.444c-.04.36-.17.661-.394.905-.267.293-.628.44-1.081.44-.391 0-.72-.12-.985-.36-.35-.319-.525-.81-.525-1.474 0-.505.131-.918.394-1.24.284-.352.676-.527 1.175-.527.426 0 .757.114.992.342zm.787-.25H9.1c.3 0 .54.086.724.257.183.172.275.413.275.723 0 .267-.082.5-.245.697-.164.198-.415.297-.754.297H8.043v1.446h-.456v-3.42zm1.778.47a.979.979 0 0 0-.415-.072h-.907v1.185h.907c.204 0 .37-.044.498-.133.128-.088.191-.244.191-.468 0-.25-.091-.422-.274-.512zm2.546.525c.164.083.288.19.374.323.082.125.137.272.165.44.024.114.036.298.036.549h-1.798c.007.253.066.456.176.609.11.152.28.229.511.229a.655.655 0 0 0 .516-.217.733.733 0 0 0 .155-.29h.406a.877.877 0 0 1-.107.306c-.06.112-.127.204-.202.275a.956.956 0 0 1-.465.252c-.1.025-.212.037-.337.037-.306 0-.565-.113-.777-.339-.212-.225-.318-.542-.318-.948 0-.4.107-.726.32-.975a1.05 1.05 0 0 1 .839-.375c.174 0 .343.041.506.124zm.152.98a1.099 1.099 0 0 0-.117-.436c-.113-.202-.302-.303-.566-.303-.19 0-.348.07-.477.209a.794.794 0 0 0-.204.53h1.364zm.695-1.048h.392v.353c.116-.145.239-.25.369-.314a.97.97 0 0 1 .433-.095c.348 0 .583.123.705.37.068.135.101.328.101.58v1.599h-.419V6.742a.863.863 0 0 0-.066-.367c-.074-.156-.207-.233-.4-.233a.8.8 0 0 0-.24.03.62.62 0 0 0-.298.205.62.62 0 0 0-.134.255c-.02.088-.03.213-.03.376v1.306h-.413V5.82zm2.375 0h.392v.353c.116-.145.239-.25.369-.314a.97.97 0 0 1 .433-.095c.348 0 .583.123.705.37.068.135.101.328.101.58v1.599h-.42V6.742a.863.863 0 0 0-.066-.367c-.073-.156-.206-.233-.398-.233a.8.8 0 0 0-.24.03.62.62 0 0 0-.299.205.62.62 0 0 0-.134.255c-.02.088-.03.213-.03.376v1.306h-.413V5.82zm3.903.068c.164.083.288.19.374.323.082.125.137.272.165.44.024.114.036.298.036.549h-1.798c.007.253.066.456.176.609.11.152.28.229.511.229a.655.655 0 0 0 .516-.217.733.733 0 0 0 .155-.29h.406a.877.877 0 0 1-.107.306c-.06.112-.128.204-.202.275a.956.956 0 0 1-.466.252c-.099.025-.211.037-.336.037-.306 0-.565-.113-.777-.339-.212-.225-.318-.542-.318-.948 0-.4.106-.726.32-.975a1.05 1.05 0 0 1 .839-.375c.174 0 .343.041.506.124zm.151.98a1.099 1.099 0 0 0-.116-.436c-.113-.202-.302-.303-.566-.303-.19 0-.349.07-.477.209a.794.794 0 0 0-.204.53h1.363zm2.229-1.048h.456c-.058.16-.187.524-.388 1.094-.15.428-.274.777-.375 1.047-.239.636-.407 1.024-.504 1.164-.098.14-.266.21-.504.21a.974.974 0 0 1-.134-.008 1.044 1.044 0 0 1-.116-.025V8.92c.072.02.124.033.156.037.032.005.06.007.084.007.077 0 .133-.012.169-.038a.352.352 0 0 0 .09-.094 11.946 11.946 0 0 0 .186-.447l-.907-2.565h.467l.658 2.03.662-2.03z"
                                    />
                                </svg>
                                <svg width="51px" height="31px" viewBox="0 0 24 15">
                                    <defs>
                                        <linearGradient
                                            id="jcpCardPlatinum"
                                            x1="4.266%"
                                            x2="41.417%"
                                            y1="33.417%"
                                            y2="66.808%"
                                        >
                                            <stop offset="0%" stopColor="#D5D5D5" />
                                            <stop offset="100%" stopColor="#A2A6A8" />
                                        </linearGradient>
                                    </defs>
                                    <path
                                        fill="url(#jcpCardPlatinum)"
                                        d="M0 2.009C0 .899.897 0 2.005 0H22c1.108 0 2.005.896 2.005 2.009v10.652c0 1.11-.897 2.009-2.005 2.009H2.005A2.005 2.005 0 0 1 0 12.661V2.009z"
                                    />
                                    <path
                                        fill="#FFF"
                                        d="M3.93 7.294c0 .289-.042.513-.126.673-.156.292-.453.437-.89.437-.251 0-.467-.07-.645-.208C2.089 8.057 2 7.81 2 7.455V7.21h.429v.245c0 .186.04.326.122.42.082.094.21.14.382.14.243 0 .402-.084.476-.253.046-.104.07-.3.07-.589V4.894h.45v2.4zm2.87-2.15c.235.227.365.487.391.777h-.444a.943.943 0 0 0-.302-.524c-.15-.129-.361-.193-.633-.193-.332 0-.6.118-.803.355-.204.236-.306.6-.306 1.088 0 .4.092.725.276.974.184.25.459.374.824.374.336 0 .592-.131.767-.394a1.51 1.51 0 0 0 .209-.544h.444c-.04.36-.17.661-.394.905-.267.293-.628.44-1.081.44-.391 0-.72-.12-.985-.36-.35-.319-.525-.81-.525-1.474 0-.505.131-.918.394-1.24.284-.352.676-.527 1.175-.527.426 0 .757.114.992.342zm.787-.25H9.1c.3 0 .54.086.724.257.183.172.275.413.275.723 0 .267-.082.5-.245.697-.164.198-.415.297-.754.297H8.043v1.446h-.456v-3.42zm1.778.47a.979.979 0 0 0-.415-.072h-.907v1.185h.907c.204 0 .37-.044.498-.133.128-.088.191-.244.191-.468 0-.25-.091-.422-.274-.512zm2.546.525c.164.083.288.19.374.323.082.125.137.272.165.44.024.114.036.298.036.549h-1.798c.007.253.066.456.176.609.11.152.28.229.511.229a.655.655 0 0 0 .516-.217.733.733 0 0 0 .155-.29h.406a.877.877 0 0 1-.107.306c-.06.112-.127.204-.202.275a.956.956 0 0 1-.465.252c-.1.025-.212.037-.337.037-.306 0-.565-.113-.777-.339-.212-.225-.318-.542-.318-.948 0-.4.107-.726.32-.975a1.05 1.05 0 0 1 .839-.375c.174 0 .343.041.506.124zm.152.98a1.099 1.099 0 0 0-.117-.436c-.113-.202-.302-.303-.566-.303-.19 0-.348.07-.477.209a.794.794 0 0 0-.204.53h1.364zm.695-1.048h.392v.353c.116-.145.239-.25.369-.314a.97.97 0 0 1 .433-.095c.348 0 .583.123.705.37.068.135.101.328.101.58v1.599h-.419V6.742a.863.863 0 0 0-.066-.367c-.074-.156-.207-.233-.4-.233a.8.8 0 0 0-.24.03.62.62 0 0 0-.298.205.62.62 0 0 0-.134.255c-.02.088-.03.213-.03.376v1.306h-.413V5.82zm2.375 0h.392v.353c.116-.145.239-.25.369-.314a.97.97 0 0 1 .433-.095c.348 0 .583.123.705.37.068.135.101.328.101.58v1.599h-.42V6.742a.863.863 0 0 0-.066-.367c-.073-.156-.206-.233-.398-.233a.8.8 0 0 0-.24.03.62.62 0 0 0-.299.205.62.62 0 0 0-.134.255c-.02.088-.03.213-.03.376v1.306h-.413V5.82zm3.903.068c.164.083.288.19.374.323.082.125.137.272.165.44.024.114.036.298.036.549h-1.798c.007.253.066.456.176.609.11.152.28.229.511.229a.655.655 0 0 0 .516-.217.733.733 0 0 0 .155-.29h.406a.877.877 0 0 1-.107.306c-.06.112-.128.204-.202.275a.956.956 0 0 1-.466.252c-.099.025-.211.037-.336.037-.306 0-.565-.113-.777-.339-.212-.225-.318-.542-.318-.948 0-.4.106-.726.32-.975a1.05 1.05 0 0 1 .839-.375c.174 0 .343.041.506.124zm.151.98a1.099 1.099 0 0 0-.116-.436c-.113-.202-.302-.303-.566-.303-.19 0-.349.07-.477.209a.794.794 0 0 0-.204.53h1.363zm2.229-1.048h.456c-.058.16-.187.524-.388 1.094-.15.428-.274.777-.375 1.047-.239.636-.407 1.024-.504 1.164-.098.14-.266.21-.504.21a.974.974 0 0 1-.134-.008 1.044 1.044 0 0 1-.116-.025V8.92c.072.02.124.033.156.037.032.005.06.007.084.007.077 0 .133-.012.169-.038a.352.352 0 0 0 .09-.094 11.946 11.946 0 0 0 .186-.447l-.907-2.565h.467l.658 2.03.662-2.03z"
                                    />
                                </svg>
                            </div>
                        )}
                    </div>
                    <div
                        className={`${cx(
                            isSliderBanner ? '' : 'sm12 md12 lg6 xl6',
                            'descContainer'
                        )} ${dt(['font-sans', 'pt-2.5', 'pr-0', 'pb-4', 'pl-0'])}`}
                    >
                        <div
                            className={`${cx('plccTitle')} ${dt([
                                'text-xlarge',
                                'leading-[1.25]',
                                'font-bold',
                                'mb-2',
                            ])}`}
                            data-automation-id="jcp_credit_card_text1"
                        >
                            {get(
                                preferences,
                                `plccBanner.${cardType}.${bannerTierType}.title`,
                                bannerDefaultTitle
                            )}
                        </div>
                        <div
                            className={`${cx('plccSubtitle', {
                                tierSubtitle: bannerTierType,
                            })} ${dt([
                                bannerTierType && ' m-auto',
                                bannerTierType && 'w-[85%]',
                                bannerTierType && 'mt-2.5',
                                'text-small',
                                'leading-[1.25]',
                                'smOnly:text-xsmall',
                            ])}`}
                            data-automation-id="jcp_credit_card_text2"
                        >
                            {bannerTierType ? (
                                <>
                                    {isPlatinumPlccCard && isThresholdExceeded ? (
                                        <span>
                                            <div>{thresholdExceededSubTitle[0]}</div>
                                            <span>{thresholdExceededSubTitle[1]}</span>
                                        </span>
                                    ) : (
                                        <span>
                                            {`${tierTypeSubTitle[0]}${spendMoreText}${tierTypeSubTitle[1]}
                                     ${tierTypeSubTitle[2]}${tierTypeSubTitle[3]}${tierTypeSubTitle[4]}`}
                                        </span>
                                    )}
                                </>
                            ) : (
                                <span className={dt(['text-small'])}>
                                    {bannerDefaultSubTitle[1]}
                                    {' -'}
                                </span>
                            )}
                            {viewDetails && (
                                <a
                                    className={`${cx('viewDetails')} ${dt([
                                        'text-black',
                                        'pl-1',
                                        'underline',
                                        'whitespace-nowrap',
                                        'text-small',
                                    ])}`}
                                    href={bannerCardMemberLink}
                                    rel="noopener noreferrer"
                                >
                                    {viewDetails}
                                </a>
                            )}
                        </div>
                    </div>
                    {isProgressBarRequired && (
                        <div>
                            <img
                                className={`${cx('currentTierImage')} ${dt([
                                    'mr-1.5',
                                    'mdOnly:w-16',
                                    'mdOnly:h-10',
                                    'smOnly:w-[54px]',
                                    'smOnly:h-10',
                                ])}`}
                                src={get(
                                    preferences,
                                    `plccBanner.${cardType}.${bannerTierType}.image`,
                                    bannerDefaultImage
                                )}
                                alt=""
                            />
                            <div
                                className={`${cx('progressBar')} ${dt([
                                    'inline-block',
                                    'relative',
                                    'h-5',
                                    'w-[55%]',
                                    'rounded-[10px]',
                                    'bg-gray-15',
                                    'border-[1px]',
                                    'border-solid',
                                    'border-gray-15',
                                    'my-0',
                                    'mx-1.5',
                                    'font-sans',
                                    'text-[10px]',
                                    'font-bold',
                                ])}`}
                                data-automation-id="jcp_card_tier_progress"
                            >
                                <div
                                    style={leftPosition}
                                    className={`${cx('spentPoints')} ${dt([
                                        'text-white',
                                        '-top-[1px]',
                                        'text-right',
                                        'relative',
                                        'bg-brand-red',
                                        'rounded-[10px]',
                                        'h-[inherit]',
                                        'pl-[0.3rem]',
                                        'pt-[0.1rem]',
                                        'pr-2',
                                        'z-[1]',
                                        'min-w-[15%]',
                                    ])}`}
                                    data_automation_id="JCP card tier process bar points"
                                >
                                    {spentAmount <= thresholdAmount
                                        ? `$${spentAmount}`
                                        : `$${thresholdAmount}`}
                                </div>
                                {spentAmount < thresholdAmount && (
                                    <span
                                        className={`${cx('threshold')} ${dt([
                                            'text-[10px]',
                                            'absolute',
                                            'top-0.5',
                                            'right-[0.5rem]',
                                            'h-[inherit]',
                                            'rounded-[10px]',
                                            'mdOnly:w-[55%]',
                                            'smOnly:w-[58%]',
                                        ])}`}
                                        data_automation_id="JCP card tier process bar endpoints"
                                    >
                                        {`$${thresholdAmount}`}
                                    </span>
                                )}
                            </div>
                            <img
                                className={`${cx('nextTierImage')} ${dt([
                                    'ml-1.5',
                                    'mdOnly:w-16',
                                    'mdOnly:h-10',
                                    'smOnly:w-[54px]',
                                    'smOnly:h-[34px]',
                                ])}`}
                                src={get(
                                    preferences,
                                    `plccBanner.${cardType}.${bannerNextTierType}.${goldNextTierImage}`,
                                    bannerDefaultImage
                                )}
                                alt=""
                            />
                        </div>
                    )}
                    <div
                        className={`${cx(
                            isSliderBanner ? '' : 'sm12 md12 lg3 xl3',
                            'ctaContainer'
                        )} ${dt(['font-sans', 'text-center'])}`}
                    >
                        <div>
                            <ThrottleFeatureRender
                                featurePath="enableDApply"
                                headerName="X-DAPPLY"
                                cookieName="DP_DAPPLY"
                            >
                                {(isEnabled) => (
                                    <>
                                        {isEnabled && (
                                            <ApplySyfLink
                                                buttonClass={`${cx(
                                                    'applySyfButton',
                                                    'applyBtn'
                                                )} ${dt([
                                                    'font-sans rounded-lg',
                                                    'p-2',
                                                    'mb-2',
                                                    'w-[200px]',
                                                    'h-10',
                                                    'leading-[1.25]',
                                                    'text-base',
                                                ])}`}
                                                loaderClass={cx('applySyfLoader')}
                                                errorClass={cx('applySyfError')}
                                                buttonType="Secondary"
                                                size="Sm"
                                                dataHref={creditCardLink}
                                            >
                                                {
                                                    /* istanbul ignore next */
                                                    (isLoading, isError) => {
                                                        if (isLoading) {
                                                            return (
                                                                <Loader
                                                                    loaderClass={cx('btnLoading')}
                                                                    themeConfig={{
                                                                        loader: cx('loader'),
                                                                        wrapper: cx('loadingImage'),
                                                                    }}
                                                                />
                                                            );
                                                        }
                                                        if (isError) {
                                                            return 'Try Again';
                                                        }
                                                        return get(
                                                            messagesTexts,
                                                            'plccBanner.ctaButtonText',
                                                            'See If You Prequalify'
                                                        );
                                                    }
                                                }
                                            </ApplySyfLink>
                                        )}
                                        {!isEnabled && !bannerTierType && (
                                            <>
                                                <Button
                                                    automationId="plcc-banner-signin-slider"
                                                    className={`${cx('applyBtn')} ${dt([
                                                        'mb-2',
                                                        'w-[200px]',
                                                        'mx-auto',
                                                    ])}`}
                                                    buttonType="Secondary"
                                                    size="Md"
                                                >
                                                    {get(
                                                        messagesTexts,
                                                        'plccBanner.ctaButtonText',
                                                        'See If You Prequalify'
                                                    )}
                                                </Button>
                                                <div
                                                    className={dt([
                                                        'font-sans',
                                                        'mb-4',
                                                        'text-small',
                                                    ])}
                                                >
                                                    {get(
                                                        messagesTexts,
                                                        'plccBanner.creditImpactText',
                                                        'No impact to your credit bureau score.'
                                                    )}
                                                </div>
                                            </>
                                        )}
                                    </>
                                )}
                            </ThrottleFeatureRender>
                        </div>
                        {!bannerTierType && (
                            <span>
                                {`${get(messagesTexts, 'plccBanner.ctaHeader', '')}`}
                                {' - '}
                                {(userState === '1' || userState === '2') &&
                                    hasJCPCard === 'false' && (
                                        <Button
                                            className={`${cx('addToWalletLink')} ${dt([
                                                'text-small',
                                                'text-black',
                                            ])}`}
                                            buttonType="Link"
                                            onClick={this.addToWallet}
                                        >
                                            {get(messagesTexts, 'plccBanner.addToWallet')}
                                        </Button>
                                    )}
                            </span>
                        )}
                        {!bannerTierType && showViewBalanceAndPayLink && (
                            <span>
                                <Button
                                    className={cx('viewBalanceLink')}
                                    buttonType="Link"
                                    onClick={() =>
                                        this.linkToCard('https://www.jcpcreditcard.com/')
                                    }
                                >
                                    {get(messagesTexts, 'plccBanner.ctaLinkText', '')}
                                    <Icon
                                        iconType="svg"
                                        width="20px"
                                        height="20px"
                                        viewBox="0 0 40 40"
                                        className="mb-half ml-half"
                                    >
                                        <ExternalLink />
                                    </Icon>
                                </Button>
                            </span>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
export default PLCCBanner;
